import { Button, Group, Modal, Stack, Text } from "@mantine/core";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { deleteRepoHostToken } from "./tokensApi";

export interface TokenDeleteModalProps {
  readonly opened: boolean;
  readonly onClose: () => void;
  readonly role: string;
  readonly onDeleted: () => void;
  readonly onFailed: (err: Error) => void;
}

// Confirm-модалка удаления токена роли.
export function TokenDeleteModal(props: TokenDeleteModalProps): ReactElement {
  const { t } = useTranslation();
  const { opened, onClose, role, onDeleted, onFailed } = props;
  const queryClient = useQueryClient();

  const deleteMutation = useMutation({
    mutationFn: () => deleteRepoHostToken(role),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ["connections", "forgejo", "tokens"],
      });
      onDeleted();
    },
    onError: onFailed,
  });

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t("connections.tokens.deleteConfirmTitle")}
      size="sm"
    >
      <Stack gap="sm">
        <Text size="sm">
          {t("connections.tokens.deleteConfirmText", { role })}
        </Text>
        <Group justify="flex-end">
          <Button variant="default" onClick={onClose}>
            {t("connections.modalCancel")}
          </Button>
          <Button
            color="red"
            onClick={() => {
              deleteMutation.mutate();
            }}
            loading={deleteMutation.isPending}
          >
            {t("connections.tokens.deleteButton")}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
